export default "__VITE_ASSET__DIJRVlS$__"